import "client-only"

import { AppChannel } from "@/config/channel"
import { useConfigParams } from "@/hooks"

export function useRedirectUrl() {
  const { channel, endCallbackUrl } = useConfigParams()

  switch (channel) {
    case AppChannel.PortaleWebFullResponsiveWwwSisalIt:
    case AppChannel.ClientDesktopSisalPoker:
      return endCallbackUrl ?? window.APP_REDIRECT_LOGIN
    default:
      return "https://appmobile.sisal.it/?appFunc=close"
  }
}
